import React, { useEffect, useState } from 'react'
import widgetService from 'live/services/widgets'
import i18n from 'live/services/i18n'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { ConfigWidget } from './components/Config'
import { Provider, connect } from 'react-redux'
import store from './redux/store'
import addStore from './redux/addStore'
import { WidgetValue } from './components/WidgetValue'
import { reducer, ChartState, ChartFields } from './redux/reducer'
import { LayerConfigInterface, StateConfigInterface } from './types'
import { CONFIG_DEFAULT_STATE } from './constants'
import styled from 'styled-components'

const BaseChart = ({ state, widget }: { state: ChartState; widget: LiveWidget }) => {
    const events = state.events
    const config = widget?.jsonConfig
    const { layersConfig } = config

    return (
        <WidgetContainer>
            {Object.values(layersConfig).map((layer: LayerConfigInterface, index: number) => (
                <WidgetValue index={index} layerConfig={layer} events={events[index]?.[0]} />
            ))}
        </WidgetContainer>
    )
}

type PropsBaseConfig = {
    config: StateConfigInterface & { properties: Array<unknown> }
    onChange: (type: string, value: unknown) => void
    fields: ChartFields
}

const BaseConfig = ({ fields, config, onChange }: PropsBaseConfig) => {
    return <ConfigWidget config={config} onChange={onChange} fields={fields} />
}

widgetService.register({
    type: 'widget-value-2',
    get name() {
        return i18n('Widget Value 2.0')
    },
    get description() {
        return i18n('Widget description')
    },
    config: {
        ...CONFIG_DEFAULT_STATE
    },
    impl: reactWidgetWrapper(BaseChart, reducer),
    ui: {
        configForm: addStore({ store })(connect(props => ({ fields: props }))(BaseConfig))
    }
})

const WidgetContainer = styled.div`
    height: inherit;
    width: inherit;
    overflow: auto;

    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
`
